import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';

import { useSublingual } from '../hooks/useSublingual';
import { useForm, useFormValidation } from '../../../../../hooks';

import { CheckboxInput, DiasSemanaSelector, LightButton, MultiFormAplicacionGotas, MultiFormFrascosSublingual, NumberInput, PrimaryButton, RadiobuttonGroup, ReactSelectSingleKeyInput, SwitchInput } from "../../../../../components";

import styles from './../Sublingual.module.css';

export const SublingualUpdate = ({ sublingualAux }) => {

    const { updateSublingualMutation: { mutate: updateSublingual, isPending } } = useSublingual();

    const [resetFields, setResetFields] = useState(true);

    const [dataStatus, setDataStatus] = useState(false);

    const { sublingual, reaccion, induccion, frascosInduccion, frecuenciaInduccion, diasFrecuenciaInduccion, diasSemanaInduccion, rangoMinimoInduccion, rangoMinimoUnidadInduccion, rangoMaximoInduccion, rangoMaximoUnidadInduccion, caducidadInduccion, caducidadUnidadInduccion, aplicacionesDataInduccion, mantenimiento, frascosMantenimiento, frecuenciaMantenimiento, diasFrecuenciaMantenimiento, diasSemanaMantenimiento, rangoMinimoMantenimiento, rangoMinimoUnidadMantenimiento, rangoMaximoMantenimiento, rangoMaximoUnidadMantenimiento, caducidadMantenimiento, caducidadUnidadMantenimiento, aplicacionesDataMantenimiento, onInputChange, onResetForm } = useForm({ sublingual: sublingualAux.inmunoterapias.sublingual, reaccion: sublingualAux.inmunoterapias.reaccion, induccion: sublingualAux.induccion.isActive, frascosInduccion: (typeof sublingualAux.induccion.frascos !== 'undefined') ? sublingualAux.induccion.frascos : [{id: moment().unix(), frasco: '1', volumenAlergeno: '', volumenTotal: ''}], frecuenciaInduccion: String(sublingualAux.induccion.frecuencia), diasFrecuenciaInduccion: sublingualAux.induccion.diasFrecuencia, diasSemanaInduccion: (typeof sublingualAux.induccion.diasSemana !== 'undefined') ? sublingualAux.induccion.diasSemana : {lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado:false, domingo: false}, rangoMinimoInduccion: sublingualAux.induccion.rangoMinimo, rangoMinimoUnidadInduccion: String(sublingualAux.induccion.rangoMinimoUnidad), rangoMaximoInduccion: sublingualAux.induccion.rangoMaximo, rangoMaximoUnidadInduccion: String(sublingualAux.induccion.rangoMaximoUnidad), caducidadInduccion: sublingualAux.induccion.caducidad, caducidadUnidadInduccion: String(sublingualAux.induccion.caducidadUnidad), aplicacionesDataInduccion: (typeof sublingualAux.induccion.aplicacionesData !== 'undefined') ? sublingualAux.induccion.aplicacionesData : [{id: moment().unix(), dosis: '', repeticiones: ''}], mantenimiento: sublingualAux.mantenimiento.isActive, frascosMantenimiento: (typeof sublingualAux.mantenimiento.frascos !== 'undefined') ? sublingualAux.mantenimiento.frascos : [{id: moment().unix(), frasco: '1', volumenAlergeno: '', volumenTotal: ''}], frecuenciaMantenimiento: String(sublingualAux.mantenimiento.frecuencia), diasFrecuenciaMantenimiento: sublingualAux.mantenimiento.diasFrecuencia, diasSemanaMantenimiento: (typeof sublingualAux.mantenimiento.diasSemana !== 'undefined') ? sublingualAux.mantenimiento.diasSemana : {lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado:false, domingo: false}, rangoMinimoMantenimiento: sublingualAux.mantenimiento.rangoMinimo, rangoMinimoUnidadMantenimiento: String(sublingualAux.mantenimiento.rangoMinimoUnidad), rangoMaximoMantenimiento: sublingualAux.mantenimiento.rangoMaximo, rangoMaximoUnidadMantenimiento: String(sublingualAux.mantenimiento.rangoMaximoUnidad), caducidadMantenimiento: sublingualAux.mantenimiento.caducidad, caducidadUnidadMantenimiento: String(sublingualAux.mantenimiento.caducidadUnidad), aplicacionesDataMantenimiento: (typeof sublingualAux.mantenimiento.aplicacionesData !== 'undefined') ? sublingualAux.mantenimiento.aplicacionesData : [{id: moment().unix(), dosis: '', repeticiones: ''}] });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation } = useFormValidation([{field: 'sublingual', default: true}, {field: 'reaccion', default: true}, {field: 'induccion', default: true}, {field: 'frascosInduccion', default: true}, {field: 'frecuenciaInduccion', default: true}, {field: 'diasFrecuenciaInduccion', default: true}, {field: 'diasSemanaInduccion', default: true}, {field: 'rangoMinimoInduccion', default: true}, {field: 'rangoMinimoUnidadInduccion', default: true}, {field: 'rangoMaximoInduccion', default: true}, {field: 'rangoMaximoUnidadInduccion', default: true}, {field: 'caducidadInduccion', default: true}, {field: 'caducidadUnidadInduccion', default: true}, {field: 'aplicacionesDataInduccion', default: true}, {field: 'mantenimiento', default: true}, {field: 'frascosMantenimiento', default: true}, {field: 'frecuenciaMantenimiento', default: true}, {field: 'diasFrecuenciaMantenimiento', default: true}, {field: 'diasSemanaMantenimiento', default: true}, {field: 'rangoMinimoMantenimiento', default: true}, {field: 'rangoMinimoUnidadMantenimiento', default: true}, {field: 'rangoMaximoMantenimiento', default: true}, {field: 'rangoMaximoUnidadMantenimiento', default: true}, {field: 'caducidadMantenimiento', default: true}, {field: 'caducidadUnidadMantenimiento', default: true}, {field: 'aplicacionesDataMantenimiento', default: true}]);

    const handleChange = (e) => {
        setDataStatus(true);
        onInputChange(e);
    }

    const handleResetFields = () => {
        setTimeout(() => {
            setResetFields(true);
        }, 1);
    }

    const handleCancelChange = () => {
        onResetForm();
        setResetFields(false);
        handleResetFields();
        setTimeout(() => {
            setDataStatus(false);
        }, 1000);
    }

    useEffect(() => {
        setTimeout(() => {
            setDataStatus(false);
        }, 1000);
    }, []);

    const onSubmit = async ( event ) => {
        event.preventDefault();
        
        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updateSublingual({ data: { sublingual, reaccion, induccion: { isActive: induccion, frascos: frascosInduccion, frecuencia: frecuenciaInduccion, diasFrecuencia: diasFrecuenciaInduccion, diasSemana: diasSemanaInduccion, rangoMinimo: rangoMinimoInduccion, rangoMinimoUnidad: rangoMinimoUnidadInduccion, rangoMaximo: rangoMaximoInduccion, rangoMaximoUnidad: rangoMaximoUnidadInduccion, caducidad: caducidadInduccion, caducidadUnidad: caducidadUnidadInduccion, aplicacionesData: aplicacionesDataInduccion }, mantenimiento: { isActive: mantenimiento, frascos: frascosMantenimiento, frecuencia: frecuenciaMantenimiento, diasFrecuencia: diasFrecuenciaMantenimiento, diasSemana: diasSemanaMantenimiento, rangoMinimo: rangoMinimoMantenimiento, rangoMinimoUnidad: rangoMinimoUnidadMantenimiento, rangoMaximo: rangoMaximoMantenimiento, rangoMaximoUnidad: rangoMaximoUnidadMantenimiento, caducidad: caducidadMantenimiento, caducidadUnidad: caducidadUnidadMantenimiento, aplicacionesData: aplicacionesDataMantenimiento } } });
            setDataStatus(false);
        }else{
          startFormValidation();
        }
    
    }

    return (
        <>
            <form onSubmit={onSubmit}>
                <div className={styles.panel}>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.subHeader}>Sublingual</div>
                        </div>
                        <div className="col">
                            <div className="float-end">
                                <SwitchInput
                                    checked={ (sublingual === 'true' || sublingual === true) ? true : false }
                                    label=''
                                    labelPosition='end'
                                    name='sublingual'
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    { (String(sublingual) === 'true') &&
                    <div className="row mb-2">
                        <div className="col">
                            <CheckboxInput
                                label="Reacción"
                                name="reaccion"
                                onChange={ handleChange }
                                required={false}
                                checked={ (reaccion === 'true' || reaccion === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">

                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">
                            
                        </div>
                    </div>
                    }
                    { (String(sublingual) === 'true') &&
                    <div className={styles.panel}>
                        <div className="row mb-2">
                            <div className="col">
                                <div className={styles.subHeader}>Inducción</div>
                            </div>
                            <div className="col">
                                <div className="float-end">
                                    <SwitchInput
                                        checked={ (induccion === 'true' || induccion === true) ? true : false }
                                        label=''
                                        labelPosition='end'
                                        name='induccion'
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        { (String(induccion) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Frascos de inmunoterapia</div>
                            </div>
                        </div>
                        }
                        { (String(induccion) === 'true') &&
                        <div className="row mb-2">
                            <div className="col">
                                {(resetFields) && 
                                <MultiFormFrascosSublingual
                                    formsStatus={ formFields['frascosInduccion'].status }
                                    name="frascosInduccion"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={frascosInduccion}
                                />
                                }
                            </div>
                        </div>
                        }
                        { (String(induccion) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Configuración de aplicaciones</div>
                            </div>
                        </div>
                        }
                        { (String(induccion) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-6">
                                <RadiobuttonGroup
                                    formFieldStatus={ formFields['frecuenciaInduccion'].status }
                                    label="Frecuencia"
                                    name="frecuenciaInduccion"
                                    onChange={ handleChange }
                                    required={ true }
                                    requiredIndicator={ false }
                                    setFormFieldValidation={ setFormFieldValidation }
                                    value={ frecuenciaInduccion }
                                    values={ [{ label: 'Semanal', key: '2' }, { label: 'Quincenal', key: '3' }, { label: 'No. de días', key: '5' }, { label: 'Dias de la semana', key: '6' }] }
                                />
                            </div>
                            <div className="col-lg-12 col-xl-6">
                                {(frecuenciaInduccion === '5') &&
                                    <NumberInput
                                        formFieldStatus={ formFields['diasFrecuenciaInduccion'].status }
                                        label="Días de periodo"
                                        min={1}
                                        name="diasFrecuenciaInduccion"
                                        onChange={ handleChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ diasFrecuenciaInduccion }
                                    />
                                }
                                {(frecuenciaInduccion === '6') &&
                                    <DiasSemanaSelector
                                        formFieldStatus={ formFields['diasSemanaInduccion'].status }
                                        label="Selección de días"
                                        name="diasSemanaInduccion"
                                        onChange={ handleChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ diasSemanaInduccion }
                                    />
                                }
                            </div>
                        </div>
                        }
                        { (String(induccion) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMinimoInduccion'].status }
                                                label="Rango mínimo"
                                                min={1}
                                                name="rangoMinimoInduccion"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMinimoInduccion }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMinimoUnidadInduccion'].status }
                                                label=""
                                                name="rangoMinimoUnidadInduccion"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMinimoUnidadInduccion}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMaximoInduccion'].status }
                                                label="Rango máximo"
                                                min={1}
                                                name="rangoMaximoInduccion"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMaximoInduccion }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMaximoUnidadInduccion'].status }
                                                label=""
                                                name="rangoMaximoUnidadInduccion"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMaximoUnidadInduccion}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['caducidadInduccion'].status }
                                                label="Caducidad"
                                                min={1}
                                                name="caducidadInduccion"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ caducidadInduccion }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['caducidadUnidadInduccion'].status }
                                                label=""
                                                name="caducidadUnidadInduccion"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={caducidadUnidadInduccion}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        { (String(induccion) === 'true') &&
                        <div className="row">
                            <div className="col">
                                {(resetFields) &&
                                <MultiFormAplicacionGotas
                                    formsStatus={ formFields['aplicacionesDataInduccion'].status }
                                    name="aplicacionesDataInduccion"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={aplicacionesDataInduccion}
                                />
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                    { (String(sublingual) === 'true') &&
                    <div className={styles.panel}>
                        <div className="row mb-2">
                            <div className="col">
                                <div className={styles.subHeader}>Mantenimiento</div>
                            </div>
                            <div className="col">
                                <div className="float-end">
                                    <SwitchInput
                                        checked={ (mantenimiento === 'true' || mantenimiento === true) ? true : false }
                                        label=''
                                        labelPosition='end'
                                        name='mantenimiento'
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        { (String(mantenimiento) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Frascos de inmunoterapia</div>
                            </div>
                        </div>
                        }
                        { (String(mantenimiento) === 'true') &&
                        <div className="row mb-2">
                            <div className="col">
                                {(resetFields) && 
                                <MultiFormFrascosSublingual
                                    formsStatus={ formFields['frascosMantenimiento'].status }
                                    name="frascosMantenimiento"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={frascosMantenimiento}
                                />
                                }
                            </div>
                        </div>
                        }
                        { (String(mantenimiento) === 'true') &&
                        <div className="row">
                            <div className="col">
                                <div className={styles.sectionHeader}>Configuración de aplicaciones</div>
                            </div>
                        </div>
                        }
                        { (String(mantenimiento) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-6">
                                <RadiobuttonGroup
                                    formFieldStatus={ formFields['frecuenciaMantenimiento'].status }
                                    label="Frecuencia"
                                    name="frecuenciaMantenimiento"
                                    onChange={ handleChange }
                                    required={ true }
                                    requiredIndicator={ false }
                                    setFormFieldValidation={ setFormFieldValidation }
                                    value={ frecuenciaMantenimiento }
                                    values={ [{ label: 'Semanal', key: '2' }, { label: 'Quincenal', key: '3' }, { label: 'No. de días', key: '5' }, { label: 'Dias de la semana', key: '6' }] }
                                />
                            </div>
                            <div className="col-lg-12 col-xl-6">
                                {(frecuenciaMantenimiento === '5') &&
                                    <NumberInput
                                        formFieldStatus={ formFields['diasFrecuenciaMantenimiento'].status }
                                        label="Días de periodo"
                                        min={1}
                                        name="diasFrecuenciaMantenimiento"
                                        onChange={ handleChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ diasFrecuenciaMantenimiento }
                                    />
                                }
                                {(frecuenciaMantenimiento === '6') &&
                                    <DiasSemanaSelector
                                        formFieldStatus={ formFields['diasSemanaMantenimiento'].status }
                                        label="Selección de días"
                                        name="diasSemanaMantenimiento"
                                        onChange={ handleChange }
                                        required={ true }
                                        requiredIndicator={ true }
                                        setFormFieldValidation={ setFormFieldValidation }
                                        value={ diasSemanaMantenimiento }
                                    />
                                }
                            </div>
                        </div>
                        }
                        { (String(mantenimiento) === 'true') &&
                        <div className="row mb-2">
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMinimoMantenimiento'].status }
                                                label="Rango mínimo"
                                                min={1}
                                                name="rangoMinimoMantenimiento"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMinimoMantenimiento }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMinimoUnidadMantenimiento'].status }
                                                label=""
                                                name="rangoMinimoUnidadMantenimiento"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMinimoUnidadMantenimiento}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['rangoMaximoMantenimiento'].status }
                                                label="Rango máximo"
                                                min={1}
                                                name="rangoMaximoMantenimiento"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ rangoMaximoMantenimiento }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['rangoMaximoUnidadMantenimiento'].status }
                                                label=""
                                                name="rangoMaximoUnidadMantenimiento"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={rangoMaximoUnidadMantenimiento}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-4">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            <NumberInput
                                                formFieldStatus={ formFields['caducidadMantenimiento'].status }
                                                label="Caducidad"
                                                min={1}
                                                name="caducidadMantenimiento"
                                                onChange={ handleChange }
                                                required={ true }
                                                requiredIndicator={ true }
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={ caducidadMantenimiento }
                                            />
                                        </div>
                                        <div className="col-xs-6 col-sm-6 col-lg-6">
                                            {(resetFields) &&
                                            <ReactSelectSingleKeyInput
                                                formFieldStatus={ formFields['caducidadUnidadMantenimiento'].status }
                                                label=""
                                                name="caducidadUnidadMantenimiento"
                                                onChange={ handleChange }
                                                required={true}
                                                requiredIndicator={false}
                                                setFormFieldValidation={ setFormFieldValidation }
                                                value={caducidadUnidadMantenimiento}
                                                values={[{ value: '1', label: 'Días' }, { value: '2', label: 'Semanas' }, { value: '3', label: 'Meses' }]}
                                            />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        { (String(mantenimiento) === 'true') &&
                        <div className="row">
                            <div className="col">
                                {(resetFields) &&
                                <MultiFormAplicacionGotas
                                    formsStatus={ formFields['aplicacionesDataMantenimiento'].status }
                                    name="aplicacionesDataMantenimiento"
                                    onFormsChange={ handleChange }
                                    setFormValidation={ setFormFieldValidation }
                                    value={aplicacionesDataMantenimiento}
                                />
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                <div className="row mb-3">
                    <div className="col-sm-12 col-md">
                        <div className='d-flex justify-content-end'>
                            <LightButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="X"
                                marginTop={false}
                                marginRight={true}
                                onClick={handleCancelChange}
                                text="Cancelar"
                                type="button"
                            />
                            <PrimaryButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="Check"
                                marginTop={false}
                                text="Guardar"
                                type="submit"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

SublingualUpdate.propTypes = {
    sublingualAux: PropTypes.object.isRequired,
}